export const ru = {
    administration: 'Администрирование',
    'advanced-forecast-description':
        'Расчет примерных расходов для разных регионов показа и ключевых фраз, и ориентировочная стоимость перехода по объявлениям.',
    blog: 'Блог',
    'budget-forecast': 'Прогноз бюджета',
    'campaigns-of-client': 'Кампании клиента',
    cases: 'Кейсы',
    club: 'Клуб',
    create: 'Создать кампанию',
    'create-campaign-for-client': 'Создание кампании для клиента',
    'deals-list': 'Список сделок {count}',
    help: 'Помощь',
    library: 'Библиотека',
    'my-campaigns': 'Мои кампании',
    'my-clients': 'Мои клиенты',
    'online-courses': 'Онлайн курсы',
    recommendations: 'Рекомендации',
    'recommendations-tooltip-content':
        'Директ пересчитывает рекомендации для ваших кампаний несколько раз в день. Посмотрите, что рассчитано в этот раз.',
    'recommendations-tooltip-header': 'Рекомендации по улучшению кампаний',
    search: 'Поиск',
    study: 'Обучение',
    'switch-to-english': 'Switch to English',
    'switch-to-russian': 'Переключиться на Русский',
    tools: 'Инструменты',
    'word-stat': 'Подбор слов',
    'word-stat-description':
        'Информация о том, сколько пользователей Яндекса в месяц ищут ту или иную фразу, и запросы, похожие по смыслу на вашу фразу.'
};
